module.exports = __webpack_public_path__ + "static/media/image_10.62dad2c6.jpg";